import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../component/layout';

import BudgetTab from './budget_tabs/budgetTab';
import BudgetStatisticsTab from './budget_tabs/budgetStatisticsTab';

function BudgetManagement() {
    const [activeTab, setActiveTab] = useState('budget');
    
    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/expense_management"}>
                                        Expense Management
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-body py-0">
                                                    <ul className="nav nav-tabs profile-tabs">
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'budget' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('budget')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-notebook me-2"></i>Budget
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'statistics' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('statistics')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-chart-line me-2"></i>Budget Statistics
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="tab-content" style={{ paddingTop: '1rem' }}>
                                                {activeTab === 'budget' && (
                                                    <BudgetTab />
                                                )}
                                                {activeTab === 'statistics' && (
                                                    <BudgetStatisticsTab />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default BudgetManagement;